import { db } from "./firebase";

export const mapImCollectionsPermission = (perm, roleLabel) => {
  if (typeof perm === "string") {
    return { label: perm, value: perm, enabled: false, role: roleLabel };
  }
  const value =
    perm?.value || perm?.permission_id || perm?.id || perm?.label || "";
  const label = perm?.label || value;
  return { label, value, enabled: false, role: roleLabel };
};

export const mapImCollectionsRole = (key, roleConfig) => {
  if (!roleConfig || roleConfig.is_active === false) {
    return null;
  }

  const roleLabel = roleConfig.role_label || roleConfig.label || key;
  const roleId = roleConfig.role_id || key;
  const permissions =
    roleConfig.additional_permissions ||
    roleConfig.additionalPermissions ||
    roleConfig.permissions ||
    [];

  return {
    id: roleId,
    label: roleLabel,
    additionalPermissions: permissions
      .filter((perm) => perm?.is_active !== false)
      .map((perm) => mapImCollectionsPermission(perm, roleLabel)),
  };
};

export const parseImCollectionsConfig = (data = {}) => {
  const rolesMapping = data?.roles_mapping || data?.roles || {};

  let roles = [];

  if (
    rolesMapping &&
    typeof rolesMapping === "object" &&
    !Array.isArray(rolesMapping)
  ) {
    roles = Object.keys(rolesMapping)
      .map((key) => mapImCollectionsRole(key, rolesMapping[key]))
      .filter(Boolean)
      .sort((a, b) => a.label.localeCompare(b.label));
  }

  if (!roles.length && Array.isArray(data?.roles)) {
    roles = data.roles.map((roleLabel) => ({
      id: roleLabel,
      label: roleLabel,
      additionalPermissions: [],
    }));
  }

  if (
    Array.isArray(data?.additionalPermissions) &&
    data.additionalPermissions.length
  ) {
    const flatPermissions = data.additionalPermissions.map((perm) => {
      const roleLabel = perm?.role || "";
      return mapImCollectionsPermission(perm, roleLabel);
    });

    roles = roles.map((role) => ({
      ...role,
      additionalPermissions: [
        ...role.additionalPermissions,
        ...flatPermissions.filter((perm) => perm.role === role.label),
      ],
    }));

    flatPermissions.forEach((perm) => {
      if (!perm.role) {
        return;
      }
      const existingRole = roles.find((role) => role.label === perm.role);
      if (!existingRole) {
        roles.push({
          id: perm.role,
          label: perm.role,
          additionalPermissions: [perm],
        });
      }
    });
  }

  return roles;
};

export const findImCollectionsRole = (rolesConfig = [], { role, roleId } = {}) =>
  rolesConfig.find(
    (item) =>
      item.label === role || item.id === roleId || item.id === role
  );

export const mapWorkerImCollectionsToForm = (
  workerRole = {},
  rolesConfig = []
) => {
  const data = { ...workerRole };
  const matchedRole = findImCollectionsRole(rolesConfig, data);

  if (!data.role && matchedRole) {
    data.role = matchedRole.label;
  }
  if (!data.roleId && matchedRole) {
    data.roleId = matchedRole.id;
  }

  data.additionalPermissions = (data.additionalPermissions || []).map((perm) => ({
    ...perm,
    enabled: true,
    value: perm.value || perm.permission_id || perm.id || "",
    label: perm.label || perm.value || perm.permission_id || "",
  }));

  return data;
};

export const buildImCollectionsWorkerPayload = ({
  formValues = {},
  rolesConfig = [],
  actionBy,
}) => {
  const selectedRole = findImCollectionsRole(rolesConfig, formValues);
  const selectedPermissions = (formValues.additionalPermissions || []).filter(
    (item) => item.enabled !== false
  );

  return {
    actionTS: new Date().toISOString(),
    actionBy,
    role: formValues.role || selectedRole?.label || "",
    roleId: formValues.roleId || selectedRole?.id || "",
    collectorId: formValues.collectorId || "",
    additionalPermissions: selectedPermissions.map((item) => ({
      label: item.label,
      value: item.value,
      permission_id: item.permission_id || item.value,
    })),
    activityFamilyId: "imCollections",
    isActive: Boolean(formValues.isActive),
  };
};

export const getImCollectionsFormComparable = (values = {}) => ({
  isActive: Boolean(values.isActive),
  role: values.role || "",
  roleId: values.roleId || "",
  collectorId: values.collectorId || "",
  additionalPermissions: (values.additionalPermissions || [])
    .map((item) => item.value || item.permission_id)
    .filter(Boolean)
    .sort(),
});

export const getImCollectionsConfig = async () => {
  try {
    const configRef = db.collection("config").doc("imCollections");
    const snapshot = await configRef.get();
    return parseImCollectionsConfig(snapshot.data() || {});
  } catch (error) {
    console.log("getImCollectionsConfig error", error);
    return [];
  }
};
